export default "__VITE_PUBLIC_ASSET__bd1346e7__"